import { get } from "lodash";

export const getMeta = state => {
  return get(state, "pageContent.meta", undefined);
};

export default getMeta;
